import { RemoteControlHealthCheckRepository } from '@/module/drive/data/repository/remote_control_health_check_repository';

export interface HealthCheckUseCase {
    (placeID: number): Promise<number>
}

const remoteControlHealthCheckUseCase = (repository: RemoteControlHealthCheckRepository): HealthCheckUseCase => async (placeID: number) => {
  try {
    return await repository(placeID);
  } catch (error) {
    throw error
  }
}

export default remoteControlHealthCheckUseCase;
